import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <span className="w-16 h-16 flex items-center justify-center rounded-md bg-primary-700 mb-6">
        <i className="ri-film-line text-accent-400 text-3xl"></i>
      </span>
      <p className="font-heading text-6xl md:text-8xl font-bold text-primary-900">404</p>
      <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mt-4">页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
      <p className="mt-3 text-sm text-foreground-600 max-w-md">你访问的页面不存在或已被移动，不如回到首页继续浏览李采潭的影视作品。</p>
      <div className="flex flex-wrap items-center justify-center gap-3 mt-7">
        <Link to="/" className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-700 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-800 transition-colors cursor-pointer">
          <i className="ri-home-4-line"></i>返回首页
        </Link>
        <Link to="/category" className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer">
          <i className="ri-grid-line"></i>浏览电影分类
        </Link>
      </div>
    </div>
  );
}